import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1E293B] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_60388886-97e9-4082-ac83-90164f951064/artifacts/elf8n8pu_image.png"
              alt="Anku Tax Consultant"
              className="h-16 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-slate-300 text-sm leading-relaxed mb-4">
              Professional tax consulting services for GST and Income Tax compliance. Your trusted partner for all tax-related matters.
            </p>
            <div className="flex gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 hover:text-[#10B981] transition-colors"
                data-testid="footer-facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 hover:text-[#10B981] transition-colors"
                data-testid="footer-twitter"
              >
                <Twitter size={20} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 hover:text-[#10B981] transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 hover:text-[#10B981] transition-colors"
                data-testid="footer-linkedin"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-300 hover:text-[#10B981] transition-colors text-sm" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-300 hover:text-[#10B981] transition-colors text-sm" data-testid="footer-link-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/gst-services" className="text-slate-300 hover:text-[#10B981] transition-colors text-sm" data-testid="footer-link-gst">
                  GST Services
                </Link>
              </li>
              <li>
                <Link to="/income-tax-services" className="text-slate-300 hover:text-[#10B981] transition-colors text-sm" data-testid="footer-link-income">
                  Income Tax Services
                </Link>
              </li>
              <li>
                <Link to="/billing" className="text-slate-300 hover:text-[#10B981] transition-colors text-sm" data-testid="footer-link-billing">
                  Billing
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-300 hover:text-[#10B981] transition-colors text-sm" data-testid="footer-link-contact">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* GST Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">GST Services</h3>
            <ul className="space-y-2">
              <li className="text-slate-300 text-sm">GST Registration</li>
              <li className="text-slate-300 text-sm">GST Return Filing</li>
              <li className="text-slate-300 text-sm">GST LUT Form</li>
              <li className="text-slate-300 text-sm">GST Audit</li>
              <li className="text-slate-300 text-sm">GST Revocation</li>
              <li className="text-slate-300 text-sm">GSTR 9C</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-slate-300 text-sm">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>Shop no. 3&4, 3rd Floor, Plot no. 53, Scheme NO. 53, Ratnalok Colony Vijay Nagar Indore. (Pin Code 452011)</span>
              </li>
              <li className="flex items-center gap-2 text-slate-300 text-sm">
                <Phone size={16} />
                <a href="tel:6268642514" className="hover:text-[#10B981] transition-colors" data-testid="footer-phone">
                  6268642514
                </a>
              </li>
              <li className="flex items-center gap-2 text-slate-300 text-sm">
                <Mail size={16} />
                <a href="mailto:VERMATAXCON121@GMAIL.COM" className="hover:text-[#10B981] transition-colors" data-testid="footer-email">
                  VERMATAXCON121@GMAIL.COM
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 text-center text-slate-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Anku Tax Consultant. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;